const searchWrapper = "_275s1q5qb0c";
const closeButton = "_275c1es8sou";

export { closeButton, searchWrapper };
import "./search.mobile.style.linaria.module.css";
//# sourceMappingURL=search.mobile.style.js.map
